// en-CA formats as YYYY-MM-DD, which is what <input type="date"> requires -- not an arbitrary locale choice.
const ISO_DATE_LOCALE = "en-CA";

export { ISO_DATE_LOCALE };
